export default {
  me: {
    __typename: 'MeMutation',
    dietMealReplaceProduct: {
      code: 200,
      __typename: 'BasicMutationSuccess',
    },
  },
};
